import { Variables } from 'react-relay';
import { MockResponseConfig } from '../../getMockResponse';
import { mockFullLoggedInUser } from '../mockFullLoggedInUser';
import { generateMockBadges } from './generateMockBadges';

// CASE ONE: HIGH 4 FIGURE NUMBER, BUT BEFORE ABBREVIATION BEGINS: 1099
// 1102 - 3 (BADGES DISPLAYED) is 1099

export const mockFullLoggedInUserManyBadgesAndCoursesCaseOne: MockResponseConfig =
  {
    ...mockFullLoggedInUser,
    UnifiedProfileQuery: (variables: Variables) => ({
      data: {
        unified: {
          unifiedProfile: {
            ...mockFullLoggedInUser.UnifiedProfileQuery(variables).data.unified
              .unifiedProfile,
            username: 'loggedinusermanybadgesandcoursescaseone',
          },
        },
      },
    }),
    ProfileBadgesQuery: (variables: Variables) => ({
      data: {
        unified: {
          unifiedProfile: {
            __typename: 'UnifiedProfile',
            id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889',
            aaid: '62587f99fdb60b0069294184',
            learning: {
              __typename: 'UnifiedLearning',
              id: 'ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184',
              recentCoursesBadges: {
                __typename: 'UnifiedProfileBadgesConnection',
                edges: generateMockBadges(
                  1102,
                  'ari:cloud:unified-portable-profile::learning/62587f99fdb60b0069294184/recent-courses',
                  'Test Course',
                  'Course Badge',
                  'https://randomuser.me/api/portraits/men/6.jpg',
                  'course',
                ),
                totalCount: 1102,
              },
            },
            badges: {
              __typename: 'UnifiedProfileBadgesConnection',
              edges: generateMockBadges(
                1102,
                'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889/badge',
                'Cloudie',
                'Answer 1 question tagged “cloud”',
                'https://s3-us-west-2.amazonaws.com/bunchball-public/sandbox/c1c0c02a686048ff93e952bf3b8ebcf9/challenge_thumbUrl-1617314058161?1617314067530',
                'kms',
              ),
              pageInfo: {
                endCursor: '1102',
                hasNextPage: false,
                hasPreviousPage: false,
                startCursor: '0',
              },
              totalCount: 1102,
            },
          },
        },
      },
    }),
  };
